module.exports = __webpack_public_path__ + "static/media/subscription-section-5.9bf63742.png";